import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CurrentlyMedical from '../views/CurrentlyMedical/CurrentlyMedical'
import PlanningPurchasing from '../views/PlanningPurchasing/PlanningPurchasing'
import RenewingCoverage from '../views/RenewingCoverage/RenewingCoverage'
import NewHealth from '../views/NewHealth/NewHealth'
import SwitchingCoverage from '../views/SwitchingCoverage/SwitchingCoverage'
import TotalAmount from '../views/TotalAmount/TotalAmount'
import RecommendedPlans from '../views/RecommendedPlans/RecommendedPlans'
import FinalQuoteDetails from '../views/FinalQuoteDetails/FinalQuoteDetails'
import CompanyCensus from '../views/CompanyCensus/CompanyCensus'
import Congratulations from '../views/Congratulations/Congratulations'
import Enrollment from '../views/Enrollment/Enrollment'
import Onboarding from '../views/Onboarding/Onboarding'
import { Paths } from './paths'
import Employees from '../views/Employees/Employees'
import { FinalQuote } from '../views/FinalQuote/FinalQuote'
import YourPlans from '../views/YourPlans/YourPlans'
import CurrentCarrier from '../views/CurrentCarrier/CurrentCarrier'
import Download from '../views/Download/Download'
import TotalAmountDependent from '../views/TotalAmount/TotalAmountDependent'
import EmployeesAmount from '../views/EmployeesAmount/EmployeesAmount'
import Broker from '../views/Broker/Broker'
import { AverageEmployeeAge } from '../views/AverageEmployeeAge/AverageEmployeeAge'
import ZipCode from '../views/ZipCode/ZipCode'

export const Router = () => (
  <Switch>
    <Route path={Paths.haveBroker} component={Broker} />
    <Route path={Paths.currentlyMedical} component={CurrentlyMedical} />
    <Route path={Paths.planningPurchasing} component={PlanningPurchasing} />
    <Route path={Paths.renewingCoverage} component={RenewingCoverage} />
    <Route path={Paths.newHealth} component={NewHealth} />
    <Route path={Paths.switchingCoverage} component={SwitchingCoverage} />
    <Route path={Paths.totalAmount} component={TotalAmount} />
    <Route path={Paths.totalAmountDependent} component={TotalAmountDependent} />
    <Route path={Paths.recommendedPlans} component={RecommendedPlans} />
    <Route path={Paths.finalQuoteDetails} component={FinalQuoteDetails} />
    <Route path={Paths.currentCarrier} component={CurrentCarrier} />
    <Route path={Paths.employees} component={Employees} />
    <Route path={Paths.finalQuote} component={FinalQuote} />
    <Route path={Paths.congratulations} component={Congratulations} />
    <Route path={Paths.companyCensus} component={CompanyCensus} />
    <Route path={Paths.enrollment} component={Enrollment} />
    <Route path={Paths.onboarding} component={Onboarding} />
    <Route path={Paths.yourPlans} component={YourPlans} />
    <Route path={Paths.download} component={Download} />
    <Route path={Paths.avgAge} component={AverageEmployeeAge} />
    <Route path={Paths.zipCode} component={ZipCode} />
    <Route path={Paths.employeesAmount} component={EmployeesAmount} />
  </Switch>
)
